import React from "react";
import { updates } from "../data/siteContent";

function BlogPostsSection() {
  return (
    <section id="recent-blog-postst" className="recent-blog-postst section light-background">
      <div className="container section-title" data-aos="fade-up">
        <h2>Inside Operating Software</h2>
        <p>
          A snapshot of how we think about delivery, product growth, and the
          kinds of work we are building around.
        </p>
      </div>

      <div className="container">
        <div className="row gy-5">
          {updates.map((item, index) => (
            <div
              className="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay={`${(index + 1) * 100}`}
              key={item.title}
            >
              <div className="post-item position-relative h-100">
                <div className="post-img position-relative overflow-hidden">
                  <img src={item.image} className="img-fluid" alt={item.title} />
                  <span className="post-date">{item.date}</span>
                </div>

                <div className="post-content d-flex flex-column">
                  <h3 className="post-title">{item.title}</h3>

                  <div className="meta d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-person"></i>
                      <span className="ps-2">{item.author}</span>
                    </div>
                    <span className="px-3 text-black-50">/</span>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-folder2"></i>
                      <span className="ps-2">{item.category}</span>
                    </div>
                  </div>

                  <hr />

                  <p className="update-summary">{item.summary}</p>

                  <a
                    href={item.link}
                    className="readmore stretched-link"
                    target={item.external ? "_blank" : undefined}
                    rel={item.external ? "noreferrer" : undefined}
                  >
                    <span>{item.linkLabel}</span>
                    <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogPostsSection;
